import { useState, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'redux/store';
import Login from '../pages/authentication/Login';
import { ConfirmEmailDialog } from 'components/authentication/confirm-email/ConfirmEmailDialog';

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);
  const profile = useSelector((s) => s.profile.profile);
  const isAuthenticated = profile != null;

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return (
    <>
      {children}
      {profile?.isEmailConfirmed === false && <ConfirmEmailDialog />}
    </>
  );
}
